// src/pages/Dashboard/Footer.jsx
import React from 'react';
import '../../../Stylesheets/Dashboard/Footer.css';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="dashboard-footer">
      <p>© {new Date().getFullYear()} <strong>Site360</strong></p>
      <div className="footer-links">
        <span><Link to="/dashboard/about"className="footer-link">About Us</Link></span>
        <span><Link to="/dashboard/Contact-us"className="footer-link">Support</Link></span>
      </div>
    </footer>
  );
};
 
export default Footer;
